import { render, staticRenderFns } from "./SettingsItemGroup.vue?vue&type=template&id=633e0569&"
import script from "./SettingsItemGroup.vue?vue&type=script&lang=ts&"
export * from "./SettingsItemGroup.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsItemGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SettingsItemGroup.vue"
export default component.exports